import { MarketingConfig } from "types"

export const marketingConfig: MarketingConfig = {
  mainNav: [
    {
      title: "Products", 
      href: "#",
      items: [
        // --- Trading ---
        {title: "Options Screener", href: "/products/options-screener", icon: "chart", description: "Real-time scanner for sellers & buyers", category: "Options"},
        {title: "Copy Trading", href: "/products/copy-trading", icon: "users", description: "Follow alerts from top traders", category: "Options"},
        {title: "Roll Assistant", href: "/products/roll-assistant", icon: "refresh", description: "Optimal roll to avoid assignment", category: "Options"},
        // --- Intelligence ---
        {title: "QW Intelligence", href: "/products/qw-intelligence", icon: "sparkles", description: "AI that understands your portfolio", category: "Intelligence"},
        {title: "Options Journal", href: "/products/options-journal", icon: "bookOpen", description: "Auto-sync P&L, chains & calendar", category: "Intelligence"},
        // --- GEX ---
        {title: "GEX Dashboard", href: "/products/gex-dashboard", icon: "activity", description: "Gamma, Vanna, Charm analysis", category: "GEX"},
        {title: "Gamma Flows", href: "/products/gamma-flows", icon: "trendingUp", description: "Real-time flow alerts", tag: "Soon", category: "GEX"},
        // --- More ---
        {title: "AI Research Agents", href: "/products/ai-research-agents", icon: "bot", description: "Portfolio monitoring & idea generation", tag: "Soon", category: "More"},
        {title: "All Products", href: "/products", icon: "grid3x3", description: "Every QuantWheel tool in one place", category: "More"},
      ]
    },
    {title: "Free Course", href: "/learn"},
    {
      title: "Resources",
      href: "#",
      items: [
        {title: "Video Guides", href: "/dashboard/videos", icon: "play", description: "Watch guides, examples & deep dives"},
        {title: "How-to guides", href: "/how-to", icon: "bookOpen", description: "Step-by-step walk-throughs"},
        {title: "Compare", href: "/compare", icon: "grid3x3", description: "QuantWheel vs other tools"},
        {title: "Release notes", href: "/releases", icon: "sparkles", description: "Latest features & improvements"},
        {title: "Roadmap", href: "/roadmap", icon: "compass", description: "What we\u2019re building next"},
      ]
    },
    {
      title: "Tools", 
      href: "#",
      items: [
        {title: "Wheel Strategy Calculator", href: "/tools/wheel-strategy-calculator", icon: "refresh", description: "Full wheel premium & break-even"},
        {title: "GEX Calculator", href: "/tools/gex-calculator", icon: "activity", description: "Free gamma exposure calculator"},
        {title: "GEX Heatmap", href: "/tools/gex-heatmap", icon: "grid3x3", description: "Strike-level gamma heatmap"},
        {title: "Max Pain", href: "/tools/max-pain-calculator", icon: "target", description: "Options max pain by expiration"},
        {title: "Earnings Scanner", href: "/tools/mispriced-earnings", icon: "trendingUp", description: "Mispriced earnings expected move"},
        {title: "Optimal Roll", href: "/tools/optimal-roll", icon: "refresh", description: "Free roll opportunity finder"},
        {title: "Options Calculator", href: "/tools/options-calculator", icon: "calculator", description: "P&L, Greeks & probability"},
        {title: "Cash-Secured Put Calculator", href: "/tools/cash-secured-put-calculator", icon: "calculator", description: "Premium, break-even & cash required"},
        {title: "Cost Basis Calculator", href: "/tools/cost-basis-calculator", icon: "calculator", description: "Real cost basis after assignment"},
        {title: "Strategy Explorer", href: "/tools/strategy-explorer", icon: "compass", description: "Visualize multi-leg strategies"},
      ]
    },
  ],
}
